import { useTheme } from 'styled-components'

import { useSiteFeatures } from './siteFeatures'

export const useStatus = () => {
  const { colors } = useTheme()
  const { isMidstreamProcess } = useSiteFeatures()

  const midstreamStatusList = [
    {
      code: 2,
      name: 'todo',
      color: colors.taskStatus.todo,
      label: 'To do',
    },
    {
      code: 3,
      name: 'inProgress',
      color: colors.taskStatus.inProgress,
      label: 'In Progress',
    },
    {
      code: 4,
      name: 'completed',
      color: colors.taskStatus.completed,
      label: 'Completed',
    },
  ]

  const downstreamStatusList = [
    {
      code: 0,
      name: 'scheduled',
      color: colors.taskStatus.scheduled,
      label: 'Scheduled',
    },
    {
      code: 1,
      name: 'permit-needed',
      color: colors.taskStatus.permitNeeded,
      label: 'Permit needed',
    },
    {
      code: 2,
      name: 'not-ready',
      color: colors.taskStatus.notReady,
      label: 'Not ready',
    },
    {
      code: 3,
      name: 'ready',
      color: colors.taskStatus.ready,
      label: 'Ready',
    },
    {
      code: 4,
      name: 'completed',
      color: colors.taskStatus.completed,
      label: 'Completed',
    },
  ]

  const getStatusList = () =>
    isMidstreamProcess ? midstreamStatusList : downstreamStatusList

  const undefinedStatus = getStatusList()[0]

  const getStatusIdByName = (statusName: string) => {
    const status = getStatusList().find((status) => status.name === statusName)

    if (!status) return undefinedStatus.code

    return status.code
  }

  const getStatusNameById = (code: number) => {
    const status = getStatusList().find((status) => status.code === code)

    if (!status) return undefinedStatus.name

    return status.name
  }

  const getStatusColorById = (code: number) => {
    const status = getStatusList().find((status) => status.code === code)

    if (!status) return undefinedStatus.color

    return status.color
  }

  const formatStatus = (status: string) => {
    let formattedStatus
    if (isMidstreamProcess) {
      formattedStatus = status.replace(/([A-Z])/g, ' $1')
    } else {
      formattedStatus = status.replace(/-/g, ' ')
    }

    const result = formattedStatus.replace(/^./, (str: string) =>
      str.toUpperCase(),
    )

    return result
  }

  return {
    getStatusList,
    getStatusColorById,
    getStatusIdByName,
    getStatusNameById,
    formatStatus,
  }
}
